// Global Search
// ==========================================================================
export default function search() {

  $('[data-search-open]').on('click', function () {
    $('.search-container').toggleClass('visible hidden');
  });

}
